export default __webpack_public_path__ + "2cf1f7b6c5ea5e29f1c3acb5936aaa5f.jpg";